module.exports = __webpack_public_path__ + "static/media/toggle-on.52c2a7ec.svg";